import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./authSlice";
import contaSlice from "./contaSlice";
import urlSlice from "./urlSlice";
import dashboardAlumnoSlice from "./dashboardAlumnosSlice";

export default configureStore({
    reducer: {
        auth: authSlice,
        conta: contaSlice,
        url: urlSlice,
        dashboardAlumno: dashboardAlumnoSlice
    },
})